import React, { useEffect, useState } from 'react';
import onboardingImage from '../../assets/Images/signin/Group 379.svg';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css/bundle';

// import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
import { TYPE_CONSTANT } from '../../constant/Web_constant';
// install Swiper modules
SwiperCore.use([Autoplay, Pagination, Navigation]);

const OnBoardingImage = () => {
  const [sliderImage, setSliderImage] = useState(null);
  useEffect(() => {
    setSliderImage(TYPE_CONSTANT?.ONBOARDING_CONFIGS?.intro_screens);
  }, [TYPE_CONSTANT]);
  return (
    <div className="  w-full h-full">
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
      >
        {sliderImage?.map((list, i) => {
          return (
            <SwiperSlide
              key={i}
              className=" w-full flex flex-col justify-center items-center"
            >
              <div className="mb-8">
                {list.image && (
                  <img
                    src={list.image}
                    alt="onboardingImage"
                    className=" max-w-[480px] h-auto object-cover"
                  />
                )}
              </div>
              <div className=" w-80">
                <p className=" mb-14 text-2xl text-primary font-medium text-center">
                  {list.text}
                </p>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default OnBoardingImage;
